// src/stores/useUserStore.js
import { create } from "zustand";
import { httpRequest } from "../utils/httpRequest";

export const useUserStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem("user")) || null,
  subscriptions: [],
  isLoadingSubs: false,
  lastFetchedSubs: 0,

  // واکشی اشتراک‌ها از سرور
  async fetchSubscriptions(force = false) {
    const { user, lastFetchedSubs, isLoadingSubs } = get();
    if (!user?._id || isLoadingSubs) return;

    const now = Date.now();
    const shouldRefetch = force || now - lastFetchedSubs > 5 * 60 * 1000; // هر ۵ دقیقه فقط یکبار

    if (!shouldRefetch) return; // کش کافی است

    set({ isLoadingSubs: true });
    try {
      const resp = await httpRequest(
        "GET",
        `/subscription/${user._id}`,
        {},
        { "x-access-token": user?.token }
      );
      set({
        subscriptions: resp?.data?.data || [],
        lastFetchedSubs: now,
      });
    } catch (e) {
      console.error("fetchSubscriptions error:", e.message);
    } finally {
      set({ isLoadingSubs: false });
    }
  },

  // بعد از خرید/لغو/تغییر اشتراک
  async refreshSubscriptions() {
    await get().fetchSubscriptions(true);
  },
}));
